import {
  ERROR_TYPE_INFO_COMPONENT,
  INFO_TYPE_INFO_COMPONENT,
  SUCCESS_TYPE_INFO_COMPONENT,
  WARNING_TYPE_INFO_COMPONENT,
} from "./types";

import InfoComponent from "@/pages/components/info/InfoComponent.vue";

export {
  ERROR_TYPE_INFO_COMPONENT,
  INFO_TYPE_INFO_COMPONENT,
  SUCCESS_TYPE_INFO_COMPONENT,
  WARNING_TYPE_INFO_COMPONENT,
  InfoComponent as default,
};
